import React, { useContext, useState } from "react";
import { UserInterfaceContext } from "../userInterfaceContext";

function Iframe() {
  const {
    showIframe,
    setShowIframe,
    frameLink,
    setFrameLink,
    frameName,
    setFrameName,
    frameLogo,
    projectDetails,
    projects,
  } = useContext(UserInterfaceContext);
  const [isLoaded, setIsLoaded] = useState(false);
  const [section, setSection] = useState("MAIN");
  const [showDetail, setShowDetail] = useState(false);
  return (
    <div
      className="iframe-container"
      style={{ display: showIframe ? "flex" : "none" }}
    >
      <div className="iframe-header">
        <div className="frame-name">
          {" "}
          <span className="project-logo">
            <img src={frameLogo} alt="" />
          </span>{" "}
          {frameName ?? "Project Name"}
          <button
            onClick={() => {
              setSection("MAIN");
              setShowDetail(false);
              setFrameLink(
                projects.find(
                  (projects) => projects.code === projectDetails.code
                ).demoLink
              );
            }}
            style={{ color: section === "MAIN" ? "white" : "black" }}
          >
            Demo
          </button>
          <button
            onClick={() => {
              setSection("DETAILS");
              setShowDetail(false);
            }}
            style={{ color: section === "DETAILS" ? "white" : "black" }}
          >
            Summary
          </button>
        
        </div>
        <div className="frame-controls">
          <span
            className="close-button"
            onClick={() => {
              setFrameLink("");
              setShowIframe(false);
            }}
          >
            X
          </span>
        </div>
      </div>
      {/* {section === "MAIN" && ( */}
      <div
        className={`iframe ${isLoaded ? "loaded" : ""}`}
        style={section === "MAIN" ? {} : { height: "0rem", overflow: "hidden" }}
      >
        <iframe
          src={frameLink}
          onLoad={() => {
            setIsLoaded(true);
          }}
        ></iframe>
      </div>
      <div
        className={`iframe ${isLoaded ? "loaded" : ""}`}
        style={
          section === "DOCUMENTATION"
            ? {}
            : { height: "0rem", overflow: "hidden" }
        }
      >
        <iframe
          src={frameLink}
          onLoad={() => {
            setIsLoaded(true);
          }}
        ></iframe>
      </div>
      {/* )} */}
      {/* {section === "DETAILS" && ( */}
      <div
        className={`iframe ${isLoaded ? "loaded" : ""} details`}
        style={
          section === "DETAILS" ? {} : { height: "0rem", overflow: "hidden" }
        }
      >
        <h2 style={{ textAlign: "center" }}>POJECT DETAILS</h2>

        <div class="max-w-4xl mx-auto my-10 p-6 bg-white shadow-md rounded-xl border border-gray-200">
          {/* <!-- Project Title --> */}
          <h2 class="text-2xl font-bold text-gray-800 mb-2">Project Summary</h2>

          {/* <!-- One-liner Summary --> */}
          <p class="text-gray-600 italic mb-4">
            {projectDetails?.summary || "NO PROJECT SUMMARY AVAILABLE"}
          </p>

          {/* <!-- Overview --> */}
          <div class="mb-4">
            <h3 class="text-lg font-semibold text-gray-700 mb-1">Overview</h3>
            <p class="text-gray-600">
              {projectDetails?.overview || "NO PROJECT OVERVIEW AVAILABLE"}
            </p>
          </div>

          {/* <!-- Key Features --> */}
          <div class="mb-4">
            <h3 class="text-lg font-semibold text-gray-700 mb-1">
              Key Features
            </h3>
            <ul class="list-disc pl-6 text-gray-600">
              {projectDetails?.features?.map((feature, index) => (
                <li key={index}>{feature}</li>
              ))}
            </ul>
          </div>

          {/* <!-- Tech Stack --> */}
          <div class="mb-4">
            <h3 class="text-lg font-semibold text-gray-700 mb-1">Tech Stack</h3>
            <ul class="list-none text-gray-600">
              <li>
                <strong>Frontend:</strong>{" "}
                {projectDetails?.techStack?.frontend?.map((frontend, index) => (
                  <span key={index}>
                    {frontend}
                    {index < projectDetails?.techStack?.frontend.length - 1
                      ? ", "
                      : ""}
                  </span>
                ))}
              </li>
              <li>
                <strong>Backend:</strong>{" "}
                {projectDetails?.techStack?.backend?.map((backend, index) => (
                  <span key={index}>
                    {backend}
                    {index < projectDetails?.techStack?.backend?.length - 1
                      ? ", "
                      : ""}
                  </span>
                ))}
              </li>
              <li>
                <strong>Database:</strong>{" "}
                {projectDetails?.techStack?.database?.map((database, index) => (
                  <span key={index}>
                    {database}
                    {index < projectDetails?.techStack?.database?.length - 1
                      ? ", "
                      : ""}
                  </span>
                ))}
              </li>
              <li>
                <strong>Tools & Services:</strong>{" "}
                {projectDetails?.techStack?.tools?.map((tool, index) => (
                  <span key={index}>
                    {tool}
                    {index < projectDetails?.techStack?.tools?.length - 1
                      ? ", "
                      : ""}
                  </span>
                ))}
              </li>
            </ul>
          </div>

          {/* <!-- Your Role --> */}
          <div class="mb-4">
            <h3 class="text-lg font-semibold text-gray-700 mb-1">My Role</h3>
            <p class="text-gray-600">
              I served as the sole developer — responsible for frontend design,
              backend logic, and deployment. This included API development,
              real-time socket integration, and UI/UX design.
            </p>
          </div>

          {/* <!-- Results / Outcomes --> */}
          <div class="mb-4">
            <h3 class="text-lg font-semibold text-gray-700 mb-1">Outcomes</h3>
            <ul class="list-disc pl-6 text-gray-600">
              {projectDetails?.outcomes?.map((outcome, index) => (
                <li key={index}>{outcome}</li>
              ))}
            </ul>
          </div>

          {/* <!-- Links --> */}
          <div class="flex gap-4 mt-4">
            <a href="#" class="text-blue-600 hover:underline" target="_blank">
              🔗 Live Demo
            </a>
            <a href="#" class="text-blue-600 hover:underline" target="_blank">
              💻 GitHub Repo
            </a>
          </div>
        </div>
      </div>
      {/* )} */}

      {/* {section === "COLLABORATE" && ( */}
      <div
        className={`iframe ${isLoaded ? "loaded" : ""}`}
        style={
          section === "COLLABORATE"
            ? {}
            : { height: "0rem", overflow: "hidden" }
        }
      >
        <p>COLLABORATE</p>
      </div>
      {/* )} */}
    </div>
  );
}

export default Iframe;
